import { SaleFactorType } from 'src/app/enum/sale-factor-type';
import { UIdModel } from './uid-model';

export class SaleProduct {
  public constructor() {}

  public brandName?: string;
  public genericCode?: number;
  public brandPersianName?: string;
  public companyId?: string;
  public companyName?: string;
  public count: number = 0;
  public inventory: number = 0;
  public countryId?: string;

  public barcode: string | undefined;
  public topUpCount: number | undefined;

  public packageCount: number = 1;
  public drugPackageCount: number = 1;

  public countryName?: string;
  public drugId?: string;
  public rowColor?: string;
  public inventoryDetails: SaleProductInventory[] = [];
  public inventoryDetailSelect?: SaleProductInventory;
  public totalCount: number = 0;
  public elementPrice: number = 0;
  public discount: number = 0;
  public discountPercent: number = 0;
  public paidPrice: number = 0;
  public insurancePrice: number = 0;
  public shareCurrencyPrice: number = 0;
}

export class SaleProductInventory {
  constructor(
    count: number,
    expireDate: string,
    id: string,
    sellPrice: number,
    stockName: string
  ) {
    this.count = count;
    this.expireDate = expireDate;
    this.id = id;
    this.sellPrice = sellPrice;
    this.stockName = stockName;
  }

  public count: number;
  public expireDate: string;
  public id: string;
  public sellPrice: number;
  public stockName: string;
}
